<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueck-anmerkungen">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Anmerkungen" | translate }}</h2>
  </ng-container>
  @if (showLableNichtOeffentlicheAnmerkungen && grundstueckEntry?.permissions?.anmerkungen) {
    <div class="text-nowrap mt-1"><i class="fas fa-info-circle"></i> {{ "NurOeffentlicheAnmerkungenWerdenAngezeigt" | translate }}</div>
  }
  <cap-standardrecht-table [hasRight]="grundstueckEntry?.permissions?.anmerkungen && ersterfassungUebergeben" [listLoader]="loader">
  </cap-standardrecht-table>
</cap-rubrik>
